import Vue from 'vue'
import Meta from 'vue-meta'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'

import LangWrapper from './views/LangWrapper/LangWrapper.vue'
import Home from './views/Home/Home.vue'

import store from './store/index'
import i18n from './i18n'

Vue.use(Router)
Vue.use(Meta)
Vue.use(i18n)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (to.name === from.name) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve({ x: 0, y: 0 })
        }, 500)
      })
    } else {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
  },
  routes: [
    {
      path: '/',
      redirect: () => {
        i18n.locale = store.getters.lang
        return `/${store.getters.lang}/`
      }
    },
    {
      path: '/it/',
      component: LangWrapper,
      children: [
        {
          path: '',
          name: 'it.home',
          component: Home,
          pathToRegexpOptions: { strict: true }
        },
        {
          path: 'prodotto/:slug/',
          name: 'it.single-product',
          component: () => import(/* webpackChunkName: "single-product" */ './views/Product/Product.vue'),
          pathToRegexpOptions: { strict: true },
          props: route => ({ slug: route.params.slug })
        },
        {
          path: 'glaxi-academy/:slug/',
          name: 'it.single-post',
          component: () => import(/* webpackChunkName: "single-post" */ './views/BlogPost/BlogPost.vue'),
          pathToRegexpOptions: { strict: true },
          props: route => ({ slug: route.params.slug })
        },
        {
          path: 'assortimento/:slug/',
          name: 'it.single-category',
          component: () => import(/* webpackChunkName: "single-category" */ './views/Category/Category.vue'),
          pathToRegexpOptions: { strict: true },
          props: route => ({ slug: route.params.slug })
        },
        {
          path: 'tag/:slug/',
          name: 'it.single-tag',
          component: () => import(/* webpackChunkName: "single-tag" */ './views/Tag/Tag.vue'),
          pathToRegexpOptions: { strict: true },
          props: route => ({ slug: route.params.slug })
        },
        {
          path: ':slug/',
          name: 'it.single-page',
          component: () => import(/* webpackChunkName: "pages" */ './views/Pages/Pages.vue'),
          props: route => ({ slug: route.params.slug }),
          pathToRegexpOptions: { strict: true }
        },
        {
          path: `not-found/`,
          name: 'it.not-found-page',
          component: () => import(/* webpackChunkName: "not-found" */ './views/NotFound/NotFound.vue'),
          pathToRegexpOptions: { strict: true }
        },
        {
          path: '*',
          redirect: { name: 'it.not-found-page' }
        }
      ]
    },
    {
      path: '/en/',
      component: LangWrapper,
      children: [
        {
          path: '',
          name: 'en.home',
          component: Home,
          pathToRegexpOptions: { strict: true }
        },
        {
          path: 'product/:slug/',
          name: 'en.single-product',
          component: () => import(/* webpackChunkName: "single-product" */ './views/Product/Product.vue'),
          pathToRegexpOptions: { strict: true },
          props: route => ({ slug: route.params.slug })
        },
        {
          path: 'glaxi-academy/:slug/',
          name: 'en.single-post',
          component: () => import(/* webpackChunkName: "single-post" */ './views/BlogPost/BlogPost.vue'),
          pathToRegexpOptions: { strict: true },
          props: route => ({ slug: route.params.slug })
        },
        {
          path: 'assortment/:slug/',
          name: 'en.single-category',
          component: () => import(/* webpackChunkName: "single-category" */ './views/Category/Category.vue'),
          pathToRegexpOptions: { strict: true },
          props: route => ({ slug: route.params.slug })
        },
        {
          path: 'tag/:slug/',
          name: 'en.single-tag',
          component: () => import(/* webpackChunkName: "single-tag" */ './views/Tag/Tag.vue'),
          pathToRegexpOptions: { strict: true },
          props: route => ({ slug: route.params.slug })
        },
        {
          path: ':slug/',
          name: 'en.single-page',
          component: () => import(/* webpackChunkName: "pages" */ './views/Pages/Pages.vue'),
          props: route => ({ slug: route.params.slug }),
          pathToRegexpOptions: { strict: true }
        },
        {
          path: `not-found/`,
          name: 'en.not-found-page',
          component: () => import(/* webpackChunkName: "not-found" */ './views/NotFound/NotFound.vue'),
          pathToRegexpOptions: { strict: true }
        },
        {
          path: '*',
          redirect: { name: 'en.not-found-page' }
        }
      ]
    }
  ]
})

// COOKIE
Vue.use(VueAnalytics, {
  id: 'UA-7409647-1',
  disabled: true,
  debug: {
    enabled: process.env.NODE_ENV === 'development',
    trace: process.env.NODE_ENV === 'production',
    sendHitTask: process.env.NODE_ENV === 'production'
  }
})

// Facebook pixel track
window.fbq('init', '7399947280077165')
// window.fbq('init', '1064097353792194')

const asyncCondition = (fn, count = 0, errors = 500) => new Promise((resolve, reject) => {
  if (count >= errors) return reject(new Error('maximum calls'))

  window.requestAnimationFrame(async () => {
    if (fn() === true) return resolve()

    try {
      await asyncCondition(fn, count + 1)
    } catch (e) {
      reject(e)
    }
  })
})

router.afterEach(async (to, from) => {
  asyncCondition(() => typeof window.fbq === 'function')
    .then(() => window.fbq('track', 'PageView'))
})

export default router
